module.exports = __webpack_public_path__ + "static/media/TeamOrange.585cdfb3.png";